module.exports = __webpack_public_path__ + "static/img/bmlc.c3b5a04d.png";